var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgU67Selected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "90 284  20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 90 288  A 4 4 0 0 1 94 284 L 106 284  A 4 4 0 0 1 110 288 L 110 300  A 4 4 0 0 1 106 304 L 94 304  A 4 4 0 0 1 90 300 L 90 288  Z ",
    fillRule: "nonzero",
    fill: "#bcefe3",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 94.28571428571429 294  L 98.57142857142857 298.2857142857143  L 105.71428571428571 288.2857142857143  ",
    strokeWidth: 4.285714285714286,
    stroke: "#3bb9a3",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU67Selected);
export default __webpack_public_path__ + "static/media/u67_selected.1b337c949c7aca7d9ff40aee2047470d.svg";
export { ForwardRef as ReactComponent };